<template>
    <Dashboard
        :title="__('Add product', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Add product', null, $page.props.profile_locale)"
        />
        <div class="grid lg:grid-cols-2 gap-3">
            <InputLabel
                id="title"
                :label="__('Title', null, $page.props.profile_locale)"
                v-model="form.title"
            />
            <InputLabel
                id="short_description"
                :label="__('Short description', null, $page.props.profile_locale)"
                v-model="form.short_description"
            />

            <InputLabel
                id="slug"
                :label="__('Slug', null, $page.props.profile_locale)"
                class="lg:col-span-2"
                v-model="form.slug"
                :placeholder="form.title ? str_slug(form.title) : ''"
            />

            <div class="flex flex-col">
                <InputLabel
                    id="price"
                    type="number"
                    :label="__('Price :value', { value: getLocale() != 'pl' ? 'EUR' : 'EUR' }, $page.props.profile_locale)"
                    class="mb-3"
                    v-model.number="form.price"
                    :disabled="form.pieces_type == 'packages'"
                />
                <InputLabel
                    id="quantity"
                    type="number"
                    :label="__('Quantity', null, $page.props.profile_locale)"
                    v-model.number="form.quantity"
                    :disabled="form.pieces_type == 'packages'"
                />
            </div>
        </div>

        <ImageUpload
            :images="form.images"
            @images-uploaded="uploadImages"
            :autosend="false"
        >
        <template #top="{data}">
            <p v-if="data && data.length" class="text-red-700 font-bold text-sm">Zdjęcie pierwsze będzie głównym zdjęciem</p>
            <p v-if="data && data.length" class="text-gray-900 font-bold text-sm">Przeciągnij aby zmienić kolejność</p>
        </template>
        </ImageUpload>

        <div class="grid grid-cols-1 gap-2 mt-3 bg-gray-100 p-2 rounded-md">
            <h3 class="font-bold border-b border-gray-300">{{__('Select product personalization options', null, $page.props.profile_locale)}}</h3>
            <p v-if="!form.options.text_engrave" class="text-sm font-semibold text-red-700">{{__('Product without personalization', null, $page.props.profile_locale)}}</p>
            <Checkbox
                :label="__('Fonts', null, $page.props.profile_locale)"
                type="checkbox"
                id="fonts"
                model="bool"
                :disabled="!form.options.text_engrave"
                v-model="form.options.fonts"
            />
            <hr class="border-gray-300">
            <Checkbox
                :label="__('Images', null, $page.props.profile_locale)"
                type="checkbox"
                id="images"
                model="bool"
                :disabled="!form.options.text_engrave"
                v-model="form.options.images"
            />
            <hr class="border-gray-300">
            <Checkbox
                :label="__('Text to engrave')"
                type="checkbox"
                id="text_engrave"
                model="bool"
                v-model="form.options.text_engrave"
            />
            <div class="ml-5" v-if="form.options.variants && form.options.text_engrave">
                <BreezeButton
                    @click="showModal = true; active = 'variant';"
                    padding="md"
                >
                    Dodaj warianty
                </BreezeButton>
                <ul class="flex list-none mt-3 space-x-1" v-if="engraveVariants.filter(selectedEngrave).length">
                    <li
                        class="flex items-center select-none pl-1 pr-3 py-1 text-xs rounded-full bg-gray-500 hover:bg-gray-600 focus:outline-none text-white"
                        v-for="item in engraveVariants.filter(selectedEngrave)" :key="item.id"
                    >
                        <SvgIcon
                            name='x-circle'
                            width="18"
                            height="18"
                            class="opacity-60 hover:opacity-100 rounded-full cursor-pointer"
                            @click="item.selected = !item.selected"
                        ></SvgIcon>
                        <div
                            v-html="item.name"
                            class="pl-1.5 pt-0.5"
                        ></div>
                    </li>
                </ul>
            </div>
            <hr class="border-gray-300">
            <Checkbox
                :label="__('Color', null, $page.props.profile_locale)"
                type="checkbox"
                id="color.status"
                model="bool"
                v-model="form.options.color.status"
            />
            <div class="ml-5" v-if="isTrue(form.options.color.status)">
                <BreezeButton
                    @click="form.options.color.value.push({title: null, color: '#ffffff'})"
                    padding="md"
                >
                    Dodaj kolor
                </BreezeButton>
                <ul class="list-none mt-3">
                    <li
                        class="flex space-x-3 items-center p-2 border-t"
                        v-for="(item, key) in form.options.color.value"
                        :key="key"
                    >
                        <div class="font-bold">#{{key + 1}}</div>
                        <InputLabel
                            :id="'color.value.'+key+'.title'"
                            :placeholder="__('Color title', null, $page.props.profile_locale)"
                            v-model="form.options.color.value[key]['title']"
                        />
                        <InputLabel
                            :id="'color.value.'+key+'.color'"
                            type="color"
                            :size="null"
                            v-model="form.options.color.value[key]['color']"
                        />
                        <div class="space-y-2">
                            <BreezeButton
                                @click="form.options.color.value.splice(key, 1)"
                                color="red"
                                padding="sm"
                                class="justify-center"
                            >
                                Usuń
                            </BreezeButton>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <CustomModal
            v-if="showModal"
            @update="ev => showModal = ev"
            modalClass="sm:w-3/4"

            :title="__('Select engrave variants', null, $page.props.profile_locale)"
        >

            <div class="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 xs gap-3">
                <div
                    class="shadow-md rounded-md overflow-hidden relative group lg:h-40 h-60"
                    v-for="item in engraveVariants" :key="item.id"
                    @click="item.selected = !item.selected"
                >
                    <img :src="item.image.url" class="transition duration-300"
                        :class="{
                            ['opacity-50'] : item.selected,
                            ['group-hover:opacity-50'] : !item.selected
                        }"
                    />

                    <div
                        class="flex flex-col absolute inset-0 z-10 transition duration-300"
                        :class="{
                            ['bg-green-400 bg-opacity-30'] : item.selected,
                            ['group-hover:bg-green-400 group-hover:bg-opacity-30'] : !item.selected
                        }"
                    >
                        <h2 class="bg-gray-900 text-gray-200 p-1 font-bold">{{ item.name }}</h2>

                            <SvgIcon
                                name="check"
                                class="m-auto opacity-0 text-green-700 rounded-full border-2 border-green-700 bg-green-100 transition duration-300"
                                :class="{
                                    ['opacity-100'] : item.selected,
                                }"
                                :size="30"
                            />
                    </div>
                </div>
            </div>
        </CustomModal>

        <div class="grid grid-cols-1 gap-2 bg-gray-100 p-2 rounded-md mt-3">
            <h3 class="font-bold border-b border-gray-300">{{__('Choose the type of pieces', null, $page.props.profile_locale)}}</h3>
            <Checkbox
                :label="__('Add more', null, $page.props.profile_locale)"
                id="pieces"
                type="radio"
                name="pieces_type"
                value="pieces"
                v-model="form.pieces_type"
            />
            <Checkbox
                :label="__('Packages', null, $page.props.profile_locale)"
                id="packages"
                type="radio"
                name="pieces_type"
                value="packages"
                v-model="form.pieces_type"
            />
            <div
                class="grid xl:grid-cols-3 lg:grid-cols-2 gap-2"
                v-if="form.pieces_type != 'none'"
            >
                <div
                    class="relative p-2 pr-10 rounded-md bg-gray-300 text-gray-700 font-bold text-md flex items-center justify-between group transition duration-300"
                    :class="[
                        isTrue(item.display) ? '' : 'bg-opacity-50'
                    ]"
                    v-for="item in defaultPieces[form.pieces_type]"
                    :key="item"
                >
                    <IconLink
                        :icon="isTrue(item.display) ? 'check' : 'x'"
                        :color="isTrue(item.display) ? 'green' : 'red'"
                        @click="item.display = ( (item.display == '1' || item.display == true) ? false : true)"
                    />
                    <span
                        class="flex items-center"
                        :class="[
                            isTrue(item.display) ? '' : 'opacity-50'
                        ]"
                    >
                        <InputLabel
                            :label="form.pieces_type == 'pieces' ? '+' : ''"
                            v-model.number="item.quantity"
                            type="number"
                            class="w-20 mx-1 flex items-center"
                            inputClass="ml-1"
                        />
                        {{ __('pieces', null, $page.props.profile_locale) }}
                    </span>
                    <span
                        class="flex items-center"
                        :class="[
                            isTrue(item.display) ? '' : 'opacity-50'
                        ]"
                    >
                        <InputLabel
                            :label="form.pieces_type == 'pieces' ? '+' : ''"
                            v-model.number="item.price"
                            type="number"
                            class="w-24 mx-1 flex items-center"
                            inputClass="ml-1"
                        />
                        <span>{{ getCurrency() }}</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="mt-4">
            <InputLabel
                id="description"
                :label="__('Description', null, $page.props.profile_locale)"
                type="quill"
                class="mt-1 block w-full"
                rows="2"
                v-model="form.description"
                :error="checkError($page.props.errors, 'description')"

            >
             </InputLabel>
        </div>
        <div class="mt-3">
            <BreezeButton
                padding="md"
                @click="addProduct"
            >
                    {{__('Save', null, $page.props.profile_locale)}}
            </BreezeButton>
        </div>

    </Dashboard>
</template>

<script>
    import { ref, watch } from 'vue';
    import Dashboard from '@/Layouts/Dashboard';
    import InputLabel from 'UI/InputLabel';
    import BreezeButton from 'UI/Button';
    import SvgIcon from 'UI/SvgIcon';
    import ImageUpload from 'UI/ImageUpload';
    import CustomModal from 'UI/CustomModal';
    import Checkbox from 'UI/Checkbox';
    import Heading from 'COMP/Heading';
    import IconLink from 'UI/IconLink';

    import { useForm } from '@inertiajs/inertia-vue3'

    import {
        getPrice,
        checkError,
        getCurrency,
        getLocale,
        str_slug,
        isTrue
    } from 'helper';

    export default {
        props: {
            engraves: [Object, Array],
        },
        setup(props){
            const variants = ref([null]);
            const showModal = ref(false);
            const active = ref(null);

            const engraveVariants = ref(props.engraves);

            engraveVariants.value.forEach(element => {
                element.selected = false;
            });

            const defaultPieces = ref({
                pieces: [
                    { quantity: 10, price: 10.99, display: true },
                    { quantity: 20, price: 20.99, display: true },
                    { quantity: 30, price: 30.99, display: true },
                ],
                packages: [
                    { quantity: 10, price: 10.99, display: true },
                    { quantity: 25, price: 25.99, display: true },
                    { quantity: 50, price: 50.99, display: true },
                    { quantity: 100, price: 100.99, display: true },
                    { quantity: 200, price: 200.99, display: true },
                    { quantity: 500, price: 500.99, display: true },
                    { quantity: 1000, price: 800.99, display: true },
                ],
            });
            const form = useForm({
                title: null,
                description: null,
                short_description: null,
                slug: null,
                price: null,
                images: null,
                quantity: 50,
                variants: [],
                pieces_type: 'pieces',
                pieces_item: [],
                options: {
                    fonts: true,
                    images: true,
                    variants: true,
                    text_engrave: true,
                    color: {
                        status: false,
                        value: [
                            {
                                title: 'White',
                                color: '#ffffff',
                            }
                        ],
                    }
                }
            })

            watch(form.options, (val, oldVal) => {
                if(!val.text_engrave) {
                    form.options.fonts = false;
                    form.options.images = false;
                }
            })

            const uploadImages = (el) => {
                form.images = el;
            }

            const addProduct = (el) => {
                form
                .transform((data) => ({
                    ...data,
                    variants: engraveVariants.value.filter(selectedEngrave),
                    price: data.pieces_type == 'packages' ? null : data.price,
                    quantity: data.pieces_type == 'packages' ? null : data.quantity,
                    pieces_item: defaultPieces.value[data.pieces_type],
                }))
                .post("/add/product", {
                    preserveScroll: true,
                    onSuccess: () => {},
                })
            }

            function selectedEngrave(element, index, array) {
                return (element.selected == true);
            }

            return {
                variants,
                form,
                showModal,
                engraveVariants,
                active,

                defaultPieces,

                uploadImages,
                addProduct,
                selectedEngrave,

                // helper
                getPrice,
                checkError,
                getCurrency,
                getLocale,
                str_slug,
                isTrue,
            }

        },
        components: {
            Dashboard,
            BreezeButton,
            InputLabel,
            SvgIcon,
            ImageUpload,
            CustomModal,
            Checkbox,
            Heading,
            IconLink,
        }

    }
</script>

